import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MUITable from "../../../../Common/MUITable";
import Loader from "../../../../Common/Loader/loader";
import useGrievanceReportStore from "../../GrievanceDetailedReport/store/grievanceReportStore";
import isGHMC from "../../../../Common/helper/helpar";

import { FrequencyBinsFilter } from "./FrequencyBinsFilter";
export const FrequencyOfBinsReport = () => {
    const {
        grievanceReportData,
        loading,
        grievanceItemsDropedownList,
        fetchgrievanceDetailedReport,
        grievanceItemList,
        setSelectedComplaintNo,
        selectComplaintNo,
        setStatus,
        selectedStatus,
        setSelectedIEName,
        selectIEName } = useGrievanceReportStore();
    const isProd = isGHMC()
    const [modalShow, setModalShow] = useState(false);
    const [selectedGrievanceData, setSelectedGrievanceData] = useState(null);
    console.log(grievanceItemsDropedownList)

    useEffect(() => {
        // Initial fetch without filters
        fetchgrievanceDetailedReport();
    }, []);

    // Function to fetch data with filters when clicking search
    const handleSearch = () => {
        fetchgrievanceDetailedReport({
            complaintNo: selectComplaintNo,
            status: selectedStatus,
            ieEngineerId: selectIEName

        });
    };

    const grievanceReportHeaderColumns = [
        { label: "Date", field: "complaintNo" },
        { label: "Shift", field: "complaintNo" },

        {
            // name: <>Cleared GVPs<br/>Points</> ,
            label: <>Total number of bins/<br /> GVPs attended in all circles (b)</>,
            field: "ieEngineerName"
        },
        { label: <>Total number of bins/<br /> GVPs in all circles (a)</>, field: "kpiCategoryName" },
        { label: "Performance Achieved", field: "description" },
        { label: "Remarks", field: "description" },

    ];

    return (
        <div style={{ width: "100%" }}>
            <div className="content">
                <div className="page-content">
                    <FrequencyBinsFilter />


                    {/* Data Table Section */}
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="top-header p-2"
                                style={{ backgroundColor: "#D7D7D7", fontWeight: "600", borderBottom: "1px solid #DDDDDD" }}>
                                <span>Frequency Of Bins/GVPs Attended Daily Report</span>
                            </div>
                            {/* Filter & Search Section */}

                            {loading ? <Loader /> : (
                                <MUITable
                                    needSRNumber
                                    columns={grievanceReportHeaderColumns}
                                    // rows={grievanceReportData}
                                    tableHeight={500}
                                />
                            )}
                        </div>



                    </div>
                </div>
            </div>
        </div>
    );
};
